import { AxiosRequestConfig } from 'axios';
import Dexie from 'dexie';
import { FilterArray } from '../../../../functions/FilterArray';
import { AnimalsInToPerform } from '../../../utils/AnimalsInToPerform';
import { IToPerform } from '../../toPerform/entities/IToPerform';
import { IAnimal } from '../entities/IAnimal';

type SearchArguments = {
  config?: AxiosRequestConfig;
  toPerformTable: Dexie.Table<IToPerform, number>;
  propriedade_id: string;
};

export class AnimalRepository {
  private repository: Dexie.Table<IAnimal, any>;

  constructor(animalTable: Dexie.Table<IAnimal, any>) {
    this.repository = animalTable;
  }

  public async findByPropriedadeId(propriedade_id: string): Promise<IAnimal[]> {
    return this.repository
      .where('propriedade_id')
      .equals(propriedade_id)
      .toArray();
  }

  public async delete(id: string): Promise<void> {
    await this.repository.delete(id);
  }

  public async search({
    propriedade_id,
    toPerformTable,
    config,
  }: SearchArguments): Promise<IAnimal[]> {
    const params = config?.params;

    const keyIgnoredCaseParams = new RegExp(params.key, 'i');
    const racaIgnoredCase = new RegExp(params.ra_a, 'i');
    const sexoIgnoredCase = new RegExp(params.sexo, 'i');
    const categoriaIgnoredCase = new RegExp(params.categoria, 'i');

    const animals = await AnimalsInToPerform({
      animalTable: this.repository,
      propriedade_id,
      toPerformTable,
    });

    const firstFilters = {
      estado: (value: any) =>
        params.estado === 'inativo'
          ? value === 'abatido' || value === 'morto' || value === 'vendido'
          : value === params.estado,
      ...(!Number(params.key) && {
        nome: (value: any) => keyIgnoredCaseParams.test(value),
      }),
      ...(Number(params.key) && {
        numero_de_identificacao: (value: string) =>
          Number(params.key) === Number(value),
      }),
    };

    const secondFilters = {
      sexo: (sexo: string) => sexoIgnoredCase.test(sexo),
      categoria: (categoria: string) => categoriaIgnoredCase.test(categoria),
      ra_a: (ra_a: string) => racaIgnoredCase.test(ra_a),
    };

    const filteredByFirstFilters = FilterArray(animals, firstFilters);

    const filteredBySecondFilters = FilterArray(
      filteredByFirstFilters,
      secondFilters,
    );

    const result =
      params.ra_a || params.categoria || params.sexo
        ? filteredBySecondFilters
        : filteredByFirstFilters;

    return result;
  }
}
